<adm-type-ahead-selector2
  label="Vælg adgangsgruppe"
  [itemTemplate]="itemTemplate()"
  [fetchFn]="fetchAccessGroups"
  [fetchByIdFn]="fetchAccessGroupById"
  [initialId]="accessGroupId() ?? undefined"
  (itemSelected)="accessGroupSelected($event)"
  identityPropertyName="id"
  [resetTrigger]="resetTrigger()">
</adm-type-ahead-selector2>
